import React from "react";
import "./AuthWrapper.css";
interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  return <div className="AuthContainer">{children}</div>;
};

export default AuthWrapper;
